{
    /* <svg xmlns="http://www.w3.org/2000/svg" width="11.488" height="12" viewBox="0 0 11.488 12"><defs><style>.a{}</style></defs></svg> */
}

import * as React from 'react';
import { DEFAULT_SVG_COLOR, SVGIcon, SVGIconProps } from '../SvgIcon';

export const GearIcon = (props: SVGIconProps) => (
    <SVGIcon width="11.488" height="12" viewBox="0 0 11.488 12" {...props}>
        <path
            fill={props.fill || DEFAULT_SVG_COLOR}
            d="M29.985,15.541l-1.031-.6a4.66,4.66,0,0,0,0-1.7l1.031-.6a.292.292,0,0,0,.133-.339,6.026,6.026,0,0,0-1.323-2.289.291.291,0,0,0-.358-.056l-1.031.6a4.566,4.566,0,0,0-1.471-.849V8.527a.29.29,0,0,0-.227-.283,6.082,6.082,0,0,0-2.642,0,.29.29,0,0,0-.227.283v1.19a4.71,4.71,0,0,0-1.471.849l-1.028-.6a.287.287,0,0,0-.358.056,5.989,5.989,0,0,0-1.323,2.289.289.289,0,0,0,.133.339l1.031.6a4.66,4.66,0,0,0,0,1.7l-1.031.6a.292.292,0,0,0-.133.339,6.026,6.026,0,0,0,1.323,2.289.291.291,0,0,0,.358.056l1.031-.6a4.566,4.566,0,0,0,1.471.849v1.19a.29.29,0,0,0,.227.283,6.082,6.082,0,0,0,2.642,0,.29.29,0,0,0,.227-.283V18.48a4.71,4.71,0,0,0,1.471-.849l1.031.6a.287.287,0,0,0,.358-.056,5.989,5.989,0,0,0,1.323-2.289A.3.3,0,0,0,29.985,15.541Zm-5.6.491A1.935,1.935,0,1,1,26.322,14.1,1.938,1.938,0,0,1,24.386,16.032Z"
            transform="translate(-18.644 -8.099)"
        />
    </SVGIcon>
);
